import { Injectable } from '@angular/core';
import * as XLSX from 'xlsx';

@Injectable({
  providedIn: 'root'
})
export class CsvExportService {

  constructor() { }

  public exportToExcel(data: any[], filename: string): void {
    if (data.length === 0) {
      console.warn('No data to export');
      return;
    }

    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Planilha1');

    XLSX.writeFile(workbook, filename, { bookType: 'xlsx', type: 'array' });
  }
}